export enum GameType {
    MultiplierMadness = 1,
    TopDog = 2,
    Bullseye = 3,
    Percentile = 4,
    Milestone = 5,
    Connect3 = 6,
    Blackout = 7,
    TopTeam = 8,
    Raffle = 9,
    Brackets = 10
};

export interface BracketTournamentRounds {
    RoundID: number;
    RoundNumber: number;
    RoundName: string;
    StartDate: Date;
    EndDate: Date;
}

export enum IntervalType {
    Day = '0',
    Week = '1',
    Month = '2'
}

export enum CHART_COLORS {
    BackgroundColor = '#DC4E78',
    BorderColor = '#DC4E78',
};
export enum GAME_COLORS {
    MultiplierMadness = '#F88894',
    TopDog = "#EBA56F",
    Bullseye = "#7BCCC8",
    Connect3 = "#BE9FCA",
    ConnectAll = "#2EA0B9",
    Milestone = "#82B4E0",
    TopTeam = "#97C93C",
    Brackets = "#8A88F1",
    Raffle = "#6A7480",
    Default = "#7BCCC8",
};